<template>
  <div class="course-box">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>年度培训计划</el-breadcrumb-item>
    </el-breadcrumb>
    <PublicSearch class="user-search" :searchData="searchData"
      @onSearch="() => { pageInfo.currentPage = 1; getData() }">
      <template #clazzName>{{ $store.state.institution }}</template>
      <template #right>
        <el-button v-buttonAuth="'system:annualPlan:import'" size="small" type="primary" class="mg-btm20"
          @click="handleAction(1)">导入</el-button>
        <el-button size="small" type="primary" class="mg-btm20" @click="handleAction(4)">下载导入模板</el-button>
        <el-button v-buttonAuth="'system:annualPlan:add'" size="small" type="primary" class="mg-btm20"
          @click="handleAction(2)">新增</el-button>
        <el-button v-buttonAuth="'system:annualPlan:export'" size="small" type="primary" class="mg-btm20"
          @click="handleAction(5)">导出</el-button>
        <el-button size="small" class="mg-btm20" @click="$router.back()">返回</el-button>
      </template>
    </PublicSearch>
    <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">
      <template #deptName="item">{{ item.row.create ? item.row.create.deptName : '无' }}</template>
      <!--      <template #examineSign="item">{{ item.row.examineSign ? '已考核' : '未考核' }}</template>-->
      <el-table-column prop="userSex" label="操作" width="160">
        <template slot-scope="scope">
          <div class="d-flex fz14 col-29f cs-pit">
            <div v-if="!scope.row.publishSign" class="operate" @click="handleAction(2, scope)">
              <span v-buttonAuth="'system:annualPlan:edit'">编辑</span>
            </div>
            <div v-if="!scope.row.publishSign" class="operate" @click="handleAction(3, scope)">
              <span v-buttonAuth="'system:annualPlan:release'">发布</span>
            </div>
            &nbsp;
            <el-popconfirm title="确认删除吗？" @confirm="removeRow(scope.$index, scope.row)">
              <div type="text" slot="reference" class="col-f4d " v-buttonAuth="'system:annualPlan:delete'">删除</div>
            </el-popconfirm>
            <div class="operate" @click="handleAction(7, scope)">
              <span v-buttonAuth="'system:annualPlan:over'">完成情况</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
    <!-- 编辑界面 -->
    <el-dialog :title="dialogData.title" :visible.sync="dialogData.visible" width="50%">
      <my-form ref="editForm" :form-config="dialogData.commonList" :dataForm="dialogData.form"
        :formRules="dialogData.rules" />
      <div slot="footer" class="dialog-footer text-rgt">
        <el-button size="small" @click='dialogData.visible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="dialogData.loading" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>
    <myImportDialog :exportUploadProperty="exportUploadProperty" :visible="exportUploadProperty.dialogVisible"
      :file-size="100" :getResult="getResult" @close="closeExportDialog"></myImportDialog>
    <!-- 完成情况 -->
    <el-dialog :title="dialogOver.title" :visible.sync="dialogOver.visible" width="50%">
      <my-form ref="editForm1" :form-config="dialogOver.commonList" :dataForm="dialogOver.form"
        :formRules="dialogOver.rules">

        <template #cover>
          <my-upload :fileList="dialogOver.form.cover" :config="{
            customAction: '/api/file/upload', limit: 3,
            accept: '.png,.jpg,.jpeg',

          }" @upload-remove="handleRemove" @upload-success="handleSuccess" @beforeUpload="beforeUpload">
            <template #tip>
              <div v-html="'注：仅支持png、jpg、jpeg格式上传,单张照片不超过5M'"></div>
            </template>
          </my-upload>
        </template>
      </my-form>
      <div slot="footer" class="dialog-footer text-rgt">
        <el-button size="small" @click='dialogOver.visible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="dialogOver.loading" @click="submitFormOver()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import myImportDialog from '@/components/myImportDialog.vue';
import api from '../../api/onlineTraining/annualPlan';
import { fileDownload, downloadFile } from "../../utils/util";
export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm,
    myImportDialog
  },
  data () {
    return {
      searchData: {
        inputList: [
          { label: '年度：', prop: 'year', type: 'select', placeholder: '请选择年度', dictionary: [] }
        ],
        searchQuery: { selectSign: '' } //  搜索参数
      }, //  搜索参数
      customColumns: [
        { label: '年度', prop: 'year' },
        { label: '计划归属部门', prop: 'deptName' },
        { label: '培训项目和内容', prop: 'itemContent' },
        { label: '培训目标', prop: 'goal' },
        { label: '培训对象', prop: 'target' },
        { label: '培训时间（月）', prop: 'times' },
        { label: '培训天数/学时', prop: 'days' },
        { label: '参训人数（人）', prop: 'peoples' },
        { label: '组织部门', prop: 'dept' },
        { label: '是否考核', prop: 'examineSign' },
        { label: '培训经费（元）', prop: 'outlay' },
        { label: '培训机构', prop: 'institution' },
        { label: '专业方向', prop: 'professionDirection' },
        { label: '完成情况', prop: 'completed', formatter: (item) => { return item ? '已完成' : '未完成' } }
      ],
      isLoading: false,
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
      dialogData: {
        title: '',
        visible: false,
        loading: false,
        commonList: [
          { type: 'select', prop: 'year', label: '年度', placeholder: '请选择年度', options: [] },
          { type: 'input', prop: 'itemContent', label: '培训项目和内容', placeholder: '请输入培训项目和内容' },
          { type: 'input', prop: 'goal', label: '培训目标', placeholder: '请输入培训目标' },
          { type: 'input', prop: 'target', label: '培训对象', placeholder: '请输入培训对象' },
          { type: 'input', prop: 'times', label: '培训时间（月）', placeholder: '请输入培训时间（月）' },
          { type: 'input', prop: 'days', label: '培训天数/学时', placeholder: '请输入培训天数/学时' },
          { type: 'number', prop: 'peoples', label: '参训人数（人）', placeholder: '请输入参训人数（人）' },
          { type: 'input', prop: 'dept', label: '组织部门', placeholder: '请输入组织部门' },
          { type: 'select', prop: 'examineSign', label: '是否考核', placeholder: '请选择是否考核', options: [] },
          { type: 'input', prop: 'outlay', label: '培训经费（元）', placeholder: '请输入培训经费（元）' },
          { type: 'input', prop: 'institution', label: '培训机构', placeholder: '请输入培训机构' },
          { type: 'input', prop: 'professionDirection', label: '专业方向', placeholder: '请输入专业方向' }
        ],
        form: {},
        rules: {
          courseName: { required: true, message: '请输入课程名称', trigger: 'blur' },
          courseCategoryId: { required: true, message: '请选择科目类别', trigger: 'change' }
        }
      }, //  弹窗
      URL: envConfig.NODE_IMG_API,
      exportUploadProperty: {
        config: {
          customAction: '/api/train/annual-training-plan/import', // 替换成你的上传地址
          accept: '.xls,.xlsx',
          headers: {
          },
          disabled: false,
          limit: 1,
          uploadData: {
            // 可选的上传数据
          },
          yourValue: [], // 双向绑定的值
        },
        dialogVisible: false
      },
      deptId: '',
      //完成情况dialod
      dialogOver: {
        title: '完成情况',
        visible: false,
        loading: false,
        annualTrainingPlanId: '',
        commonList: [
          {
            type: 'select', prop: 'completed', label: '完成情况', options: [{
              label: '已完成',
              id: true
            }, {
              label: '未完成',
              id: false
            }]
          },
          {
            prop: 'cover',
            label: '图片',
          },
        ],
        form: { completed: [] },

        viewForm: {}, //  查看数据
        rules: {
          completed: { required: true, message: '请选择完成情况', trigger: 'blur' },
          cover: { required: true, message: '请上传图片', trigger: 'change' },
        }
      },
    }
  },
  created () {
    this.deptId = this.$route.query.deptId;
    this.getDictionary();
    this.getData();
  },
  methods: {
    getResult () {
      return api.annualPlanImportRes();
    },
    closeExportDialog () {
      this.exportUploadProperty.dialogVisible = false;
      this.getData();
      this.exportUploadProperty.config.yourValue = [];
    },
    getDictionary () {
      const year = new Date().getFullYear();
      const yearList = [];
      for (let i = year - 5; i <= year + 5; i++) {
        yearList.push({ label: i, id: i.toString() });
      }
      this.searchData.inputList[0].dictionary = this.dialogData.commonList[0].options = yearList || [];
      this.dialogData.commonList[8].options = [
        { label: '是', id: '是' },
        { label: '否', id: '否' }
      ]
    },
    //  改变分页及大小
    callFather (data) {
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      const params = {
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
        deptId: this.deptId
      };
      const res = await api.annualPlanPage(Object.assign(this.searchData.searchQuery, params));
      this.tableData = res.data.records;
      this.pageInfo.total = res.data.total;
    },
    async handleAction (index, data) {
      switch (index) {
        case 1:
          this.exportUploadProperty.dialogVisible = true;
          this.exportUploadProperty.tableData = { total: 0, failCnt: 0 };
          this.exportUploadProperty.config.yourValue = [];
          break;
        case 2:
          if (data) {
            this.dialogData.form = { ...data.row };
          } else this.dialogData.form = {};
          this.dialogData.title = data ? '编辑' : '添加';
          this.dialogData.visible = true;
          break;
        case 3:
          await api.annualPlanPublish({ annualTrainingPlanId: data.row.annualTrainingPlanId });
          data.row.publishSign = true;
          this.$message({ message: '发布成功', type: 'success' });
          break;
        case 4:
          fileDownload(envConfig.NODE_API + '/static/templates/annualTrainingPlan.xlsx', '年度培训计划导入模版.xlsx');
          break;
        case 5:
          downloadFile(await
            api.annualPlanExport(Object.assign(this.searchData.searchQuery, {
              pageNum: this.pageInfo.currentPage,
              pageSize: this.pageInfo.pageSize,
              deptId: this.deptId
            }), {
              responseType: 'blob',
              isExport: true
            }), 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', `年度培训任务${new Date().getTime()}`);
          break;
        case 7:
          this.dialogOver.form = { cover: data.row.completedAttachment || [], completed: data.row.completed };
          this.dialogOver.visible = true;
          this.dialogOver.annualTrainingPlanId = data.row.annualTrainingPlanId;
          break;
      }
    },
    //  提交
    submitForm () {
      const params = {
        ...this.dialogData.form,
        deptId: this.deptId
      };
      this.$refs.editForm.$refs.form.validate(async valid => {
        if (!valid) return false;
        const url = params.annualTrainingPlanId ? 'annualPlanEdit' : 'annualPlanAdd';
        const res = await api[url](params);
        this.$message({ message: params.annualTrainingPlanId ? '编辑成功' : '添加成功', type: 'success' });
        this.dialogData.visible = false;
        await this.getData();
      });
    },

    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    },
    removeRow (index, row) {
      api.annualPlanRemove([row.annualTrainingPlanId]).then(res => {
        this.$message({ message: '删除成功', type: 'success' });
        this.getData();
      });
    },
    // 完成情况
    //  封面上传限制
    beforeUpload (rawFile, fun) {
      const get = _ => {
        if (this.dialogOver.form.cover.length >= 3) {
          this.$store.state.loading = false;
          this.$message({ message: '最多上传3张图片！', type: 'error' })
          return false;
        }
        if (!rawFile.name.includes('png') && !rawFile.name.includes('jpg') && !rawFile.name.includes('jpeg')) {
          this.$store.state.loading = false;
          this.$message({ message: '请上传正确的格式！', type: 'error' })
          return false;
        } else if (rawFile.size / 1024 / 1024 > 5) {
          this.$store.state.loading = false;
          this.$message({ message: '超过5MB上传大小！', type: 'error' })
          return false;
        }
        return true;
      };
      fun(get());
    },
    //  封面上传成功
    handleSuccess (data, file) {
      this.dialogOver.form.cover.push({
        name: file.name,
        url: envConfig.NODE_IMG_API + data.data.fileKey,
        fileKey: envConfig.NODE_IMG_API + data.data.fileKey,
        newFileKey: data.data.fileKey,
        size: data.size,

      });
      this.$store.state.loading = false;
    },
    //  删除
    handleRemove (fileData) {
      const index = this.dialogOver.form.cover.findIndex(res => res.uid === fileData.uid || res.fileKey === fileData.fileKey || res.url === fileData.url);
      this.dialogOver.form.cover.splice(index, 1);
    },
    submitFormOver () {
      this.$refs.editForm1.$refs.form.validate(async valid => {
        if (!valid) return false;
        const params = {
          "annualTrainingPlanId": this.dialogOver.annualTrainingPlanId,
          "completed": this.dialogOver.form.completed,
          completedAttachment: this.dialogOver.form.cover
        }
        api.completed(params).then(res => {
          this.$message({ message: '提交成功', type: 'success' });
          this.dialogOver.visible = false;
          this.getData()
        })

      })
    },
  }
}
</script>

<style lang="scss" scoped>
.course-box {
  height: 100%;

  .user-search {
    margin-top: 20px;
  }

  .operate {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }

  .view-list {
    width: 70%;
    margin: 0 auto;
    font-size: 16px;

    .view-item {
      display: flex;
      align-items: flex-start;
      padding: 5px 0;

      .view-label {
        width: 100px;
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss">
.el-loading-mask {
  z-index: 5000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/annualPlan.vue